module.exports = __webpack_public_path__ + "static/media/Playarone_primary_light.5e393b9a.svg";